import { toast } from 'react-toastify'
import {
  getAllCategories,
  getCategoriesNameById,
  getCategoryById,
  getResourcesById,
} from '../../api/admin/resources'
import {
  resourceDocumentResponse,
  resourceRespose,
  // resourcesCategories,
  resourcesCategoriesResponse,
  // resourcesCategoriesResponse2,
  resourcesCountRes,
} from '../../utils/types'

export const getCategoriesData = async (
  // currentPage: number,
  sortBy: string,
  sortOrderValue: string
): Promise<resourcesCountRes> => {
  const response = (await getAllCategories(
    // currentPage,
    sortBy,
    sortOrderValue
  )) as resourcesCategoriesResponse
  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getCategoriesDataById = async (
  id: string,
  // currentPage: number,
  sortBy: string,
  sortOrderValue: string,
  schoolId: string
): Promise<resourcesCountRes> => {
  const response = (await getCategoryById(
    id,
    // currentPage,
    sortBy,
    sortOrderValue,
    schoolId
  )) as resourcesCategoriesResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getCategoryNameById = async (
  id: string,
  schoolId: string
): Promise<resourcesCountRes> => {
  const response = (await getCategoriesNameById(
    id,
    // currentPage,

    schoolId
  )) as resourcesCategoriesResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getResourceDataById = async (
  id: string,
  schoolId: string,
  currentPage: number,
  sortBy: string,
  sortOrderValue: string
): Promise<resourceRespose> => {
  const response = (await getResourcesById(
    id,
    schoolId,
    currentPage,
    sortBy,
    sortOrderValue
  )) as resourceDocumentResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}
